import { SHOP_THIS_STORE_ACTIONS } from '@tcp/core/src/components/features/browse/ShopThisStore/container/ShopThisStore.constants';
import { SEARCH_REDUCER_ACTION_PATTERN } from '@tcp/core/src/constants/reducer.constants';

// eslint-disable-next-line import/prefer-default-export
export const getSlpProducts = (payload) => {
  return {
    type: `${SEARCH_REDUCER_ACTION_PATTERN}GET_SLP_PRODUCTS`,
    payload,
  };
};

export const showShopThisStoreNotifications = (payload) => {
  return {
    type: SHOP_THIS_STORE_ACTIONS.SHOW_SHOP_THIS_STORE_NOTIFICATION,
    payload,
  };
};
